import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ams-media",
  "use": "icon-ams-media-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ams-media\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0c282.4 0 512 229.6 512 512s-229.6 512-512 512S0 794.4 0 512 229.6 0 512 0z m256 510.4c0-20.8-11.2-40.8-28.8-51.2l-327.2-192c-9.6-7.2-21.6-11.2-34.4-11.2-32 0.8-57.6 26.4-57.6 59.2v1.6l1.6 388.8v9.6c2.4 30.4 27.2 53.6 57.6 53.6 12.8 0 24.8-4 35.2-12l324.8-193.6c17.6-12 28.8-31.2 28.8-52.8z\" p-id=\"2628\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol